'use client';

import { useTranslations } from 'next-intl';
import { SidebarResizeHandle } from '@components/ui/sidebar';

export default function AppSidebarResizeHandle() {
  const t = useTranslations('app-chrome');
  return (
    <SidebarResizeHandle
      label={t('resize-sidebar')}
      valueText={width => t('sidebar-width', { width })}
    />
  );
}
